// src/pages/TermsOfService.tsx
import React from 'react';
import styles from './StaticPage.module.css';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.pageTitle}>Terms of Service</h1>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Acceptance of Terms</h2>
        <p>
          By accessing or using this website, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, please do not use our website.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>2. User Accounts</h2>
        <p>
          You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>3. Community Conduct</h2>
        <p>
          We expect all members of The Frontier Initiative Corporation (TFIC) to engage respectfully. Harassment, hate speech, and any form of abusive behavior will not be tolerated.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>4. Content Ownership</h2>
        <p>
          Content you upload or submit remains yours; however, by uploading it to this site, you grant TFIC a non-exclusive, royalty-free license to use it within the community.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>5. Changes to Services</h2>
        <p>
          We reserve the right to modify or discontinue any part of the website or services at any time without prior notice.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>6. Disclaimer</h2>
        <p>
          This website and all associated services are provided "as is" without warranties of any kind. TFIC is not responsible for downtime, errors, or third-party disruptions.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>7. Limitation of Liability</h2>
        <p>
          In no event shall TFIC be liable for any indirect, incidental, special, or consequential damages arising out of the use of the website.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>8. Governing Law</h2>
        <p>
          These Terms are governed by and construed in accordance with the laws applicable to TFIC’s organizational operations, regardless of your location.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>9. Contact</h2>
        <p>
          If you have any questions about these Terms, please reach out via our <a href="https://discord.gg/HMcSRn8ZKc" target="_blank" rel="noopener noreferrer">Discord Server</a>.
        </p>
      </section>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>10. Medical SOS Emergency System</h2>
        <p>
          The Medical SOS system is designed for in-game emergency medical assistance within Star Citizen. By using this service:
        </p>
        <ul className={styles.list}>
          <li>You acknowledge that all medical tickets are for <strong>in-game purposes only</strong> and not real-world medical emergencies.</li>
          <li>You consent to the collection and storage of location data, emergency details, and chat communications for up to 90 days.</li>
          <li>You understand that your medical tickets and chat messages are visible to assigned medics and administrators for coordination and moderation.</li>
          <li>You agree that chat communications are operational in nature and have no expectation of privacy.</li>
          <li>You acknowledge that abuse of the medical system (false emergencies, harassment, inappropriate content) may result in account suspension or termination.</li>
          <li>You understand that we may review chat logs for moderation, compliance, and service improvement purposes.</li>
        </ul>
        <p>
          Medics and administrators are expected to maintain professionalism and confidentiality. Misuse of access to medical data may result in removal from medical positions.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>11. Age Restrictions</h2>
            <p>
                By using this website, you affirm that you are at least 13 years old. If you are under the age of majority in your jurisdiction, you must have your parent or guardian’s consent to use this site.
            </p>
        </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>12. Changes to Terms</h2>
        <p>
            We may update these Terms of Service at any time without prior notice. Your continued use of the website constitutes acceptance of any changes. We encourage you to review this page periodically.
        </p>
      </section>

      <section className={styles.section}>
       <h2 className={styles.sectionTitle}>13. Termination</h2>
        <p>
            We reserve the right to suspend or terminate your account at our discretion if you violate these Terms or engage in behavior that negatively impacts the community.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>14. External Links</h2>
        <p>
            Our website may contain links to third-party websites or services. We do not control or endorse the content, products, or services offered by these third parties and are not responsible for their practices or policies. Use external sites at your own risk.
        </p>
      </section>

      <div className={styles.divider}></div>

      <p className={styles.footer}>
        Last updated: December 5, 2025
      </p>
      <p className={styles.helpLink}>
        Have questions or need account assistance? <a href="/data-request">Submit a Data Request</a>
      </p>

    </div>
  );
};

export default TermsOfService;
